const TYPES = Object.freeze({
});

const stateObject = {
  isVisible: false,
  isBrighten: false,
  currentIndex: -1,
};

const getters = {
  isVisible: (state) => {
    return state.isVisible
  },
  isBrighten: (state) => {
    return state.isBrighten
  },
  currentIndex: (state) => {
    return state.currentIndex
  },
};

const mutations = {
  SHOW(state) {
    state.isVisible = true
  },
  HIDE(state) {
    state.isVisible = false
  },
  SET_CURRENT_INDEX(state, index) {
    state.currentIndex = index
  },
  SET_BRIGHTNESS(state, isBrighten) {
    state.isBrighten = isBrighten
  }
};

const actions = {
};

export default {
  namespaced: true,
  state: stateObject,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/page-navigation.js